import React from 'react';
import type ProjectRoleActorDetail from '@atlassian/jira-spa-apps-admin-pages-performance-project-role-actor/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectRoleActorDetail = lazyForPaint<typeof ProjectRoleActorDetail>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-project-role-actor" */ '@atlassian/jira-spa-apps-admin-pages-performance-project-role-actor'
		),
	),
);

export const ProjectRoleActorMetricDetail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectRoleActorDetail}
		pageId="system-performance-metric-detail-project-role-actor"
		shouldShowSpinner
	/>
);
